module.exports = __webpack_public_path__ + "90365dd21de1dc618c42096639a7e961.woff2";